import { isEmpty } from "utils/validationUtil";
import {AES, enc} from 'crypto-js';
import { ENCRYPTION_KEY } from "AppConstants";

// Backed by localStorage, not sessionStorage: sessionStorage is scoped to one tab, so a second
// tab opened on an empty store and forced the user to log in again (HRMS-50).

/**
 * get value against @Param key
 * whether JSON to parse - true if value is an Object
 */
const decrypt = (val) => {
    const decrypted = AES.decrypt(val, ENCRYPTION_KEY);
    const decryptedString = decrypted.toString(enc.Utf8);
    return decryptedString;
}

export function getItem(key, isJsonToParse = false, isDecryptionRequired = true) {
    var val = localStorage.getItem(key);
    if(isEmpty(val)) return null;

    if(typeof val === "boolean") return val;

    var toReturn = null;

    try {
        if(isDecryptionRequired){
            toReturn = isJsonToParse ? JSON.parse(decrypt(val)) : decrypt(val);
        }
        else{
            toReturn = val;
        }
    } catch(error) {
        if(error.message.indexOf("is not valid JSON") >= 0) toReturn = val;
    }
    return toReturn;
}

export function setItem(key, val) {
    if(isEmpty(key)) return false;

    if(typeof val === "boolean" || val === null){
        localStorage.setItem(key, val);
        return true;
    }

    const envryptedString = typeof val === "object" ? AES.encrypt(JSON.stringify(val), ENCRYPTION_KEY) : AES.encrypt(val, ENCRYPTION_KEY);
    localStorage.setItem(key, envryptedString.toString());
    return true;
}
